/* eslint-disable no-unused-vars */
// @flow
import React, { useState, useEffect } from 'react';
import { FastField, Field } from 'formik';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import Checkbox from '@components/Checkbox';
import { phone } from 'phone';
import TagManager from 'react-gtm-module';

import Input from '@components/Input';
import Textarea from '@components/Textarea';
import ButtonRadio from '@components/ButtonRadio';
import InputPhone from '@components/InputPhone';

import { DATA_LAYER_NAME } from '@lib/constants';

import { isEmpty } from 'lodash';

import { StyledInput } from '@styles/inputs';
import { StyledTextarea } from '@lib/styles/textareas';
import { StyledLabelNew } from '@styles/labels';

import { createCandidate, resetCandidateCreate } from '@redux/components/CandidateCreate/actions';

import { withTranslation, Trans } from '@i18n';

import { withFormik } from '@lib';
import type { GlobalState } from '@globalTypes';
import { getInternationalPhone } from '@services/phone';
import { PhoneCode } from './countryCode';

import {
  StyledFormGrid,
  StyledItem,
  StyledCheckbox,
  TermsAndConditionsWrapper,
  StyledRadioGroup,
  StyledItemSpacing,
  StyledFillOut,
  StyledLabelTextWrapper,
  StyledHeadWrapper,
  StyledHeadTitle,
  StyledHeadSubtitle,
  StyledTextArea,
  StyledtextGridUnit,
  StyledValidationMessage,
  StyledButtonSubmit
} from './styles';

const optionalFields = ['gender'];
const mandatoryFields = ['first_name', 'last_name', 'email', 'phone', 'phone_code'];
const fieldNames = [...optionalFields, ...mandatoryFields];

const ContactPageComponent = ({
  handleSubmit,
  setFieldValue,
  sending,
  resetCandidateCreate,
  values,
  StyledCustomUnit,
  StyledCustomEmailUnit,
  t,
  newt,
  formName,
  treatment,
  title,
  subtitle,
  clickEvent,
  created,
  contactUs,
  modalCreated,
  formId,
  onTimeSelect,
  treatmentFormName,
  modalState,
  setModalSlide,
  validMessage,
  resetForm,
  isModal,
  signUp,
  handleChange,
  errors,
  touched,
}) => {
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const [hasFocused, setHasFocused]: [boolean, (hasFocused: any) => void] = useState(false);
  const [formCreated, setFormCreated] = useState(false);

  useEffect(() => {
    if ((created && formCreated) || (modalCreated && formCreated)) {
      onTimeSelect();
      if (setModalSlide) {
        setModalSlide(2);
      }
    }

    return () => {
      setFormCreated(false);
    };
  }, [created, modalCreated]);

  useEffect(() => {
    // eslint-disable-next-line no-empty
    if (modalState) {
    }
  }, [modalState]);

  // const withFormId = key => `${formId || formName}-${key}`;

  const withFormId = (key) => {
    if (isModal) {
      return `${formId || formName}-${key}-modal`;
    }
    return `${formId || formName}-${key}`;
  };

  const textAreaRows = treatmentFormName ? 2 : 4;

  const [validateMessage, setValidateMessage] = useState(false);
  useEffect(() => {
    if (phone(values.phone).isValid) {
      setValidateMessage(false);
    }
  }, [values.phone]);
  useEffect(() => {
    resetCandidateCreate(isModal);
    resetForm();
    fetch('https://ipapi.co/json')
      .then(res => res.json())
      .then((response) => {
        // eslint-disable-next-line no-unused-expressions
        // eslint-disable-next-line no-unused-expressions
        response.city && setFieldValue('address_city', response.city || '');
        const internationalPhone: string = getInternationalPhone(
          PhoneCode[response.country_code],
          ''
        );
        // eslint-disable-next-line no-unused-expressions
        response.country_code && setFieldValue('phone', internationalPhone || '');
        // eslint-disable-next-line no-unused-expressions
        response.country_name && setFieldValue('country', response.country_name || '');
      })
      .catch(() => {});
  }, [resetCandidateCreate, modalState]);

  const isAnyValueEmpty: boolean = mandatoryFields.some(fieldName => isEmpty(values[fieldName]));

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setFieldValue('phone', formattedValue);
    if (data.countryCode) {
      setFieldValue('phone_code', data.countryCode.toUpperCase());
    }
    if (!values.country) {
      setFieldValue('country', data.name);
    }
  };


  if ((modalState && modalCreated) || (!modalState && created)) {
    trackCreated(treatment);
    if (formName === 'MiniFlowForm') {
      clickEvent();
    }
    return null;
  }

  const customEmailDesktopSize = treatmentFormName === 'FinderForm' ? 6 / 12 : 6 / 12;
  return (
    <StyledFormGrid
      onFocus={(): void => setHasFocused(true)}
      flowForm={formName === 'MiniFlowForm'}
      finderForm={formName === 'FinderForm'}
      treatmentFormName={treatmentFormName}
    >
      {title && subtitle && (
        <StyledHeadWrapper>
          <StyledHeadTitle>{title}</StyledHeadTitle>
          <StyledHeadSubtitle>{subtitle}</StyledHeadSubtitle>
        </StyledHeadWrapper>
      )}

      {!treatmentFormName && !signUp && (
        <StyledFillOut
          finderForm={formName === 'FinderForm'}
          treatmentFormName={treatmentFormName}
          isModal={isModal}
        >
          {t('FillOut')}
        </StyledFillOut>
      )}
      {signUp && (
        <StyledFillOut
          finderForm={formName === 'FinderForm'}
          treatmentFormName={treatmentFormName}
          isModal={isModal}
        >
          {t('SignUp')}
        </StyledFillOut>
      )}

      <StyledItemSpacing
        finderForm={formName === 'FinderForm'}
        treatmentFormName={treatmentFormName}
      >
        <StyledRadioGroup treatmentFormName={treatmentFormName}>
          <Field
            name="gender"
            formValue="male"
            id={withFormId('male')}
            component={ButtonRadio}
            label={t('Mr')}
          />
          <Field
            name="gender"
            formValue="female"
            id={withFormId('female')}
            component={ButtonRadio}
            label={t('Mrs')}
          />
        </StyledRadioGroup>
      </StyledItemSpacing>

      <StyledCustomUnit treatmentFormName={treatmentFormName}>
        <StyledLabelNew
          htmlFor={withFormId('first_name')}
          finderForm={formName === 'FinderForm'}
          flowForm={formName === 'MiniFlowForm'}
          treatmentFormName={treatmentFormName}
        >
          {`${t('FirstName')}*`}
        </StyledLabelNew>
        <FastField
          name="first_name"
          id={withFormId('first_name')}
          component={Input}
          inputComponent={StyledInput}
        />
      </StyledCustomUnit>
      <StyledCustomUnit treatmentFormName={treatmentFormName}>
        <StyledLabelNew
          treatmentFormName={treatmentFormName}
          htmlFor={withFormId('last_name')}
          finderForm={formName === 'FinderForm'}
          flowForm={formName === 'MiniFlowForm'}
        >
          {`${t('LastName')}*`}
        </StyledLabelNew>
        <FastField
          name="last_name"
          id={withFormId('last_name')}
          component={Input}
          inputComponent={StyledInput}
        />
      </StyledCustomUnit>

      <StyledCustomEmailUnit
        size={{ mobile: 1, desktop: customEmailDesktopSize }}
        treatmentFormName={treatmentFormName}
      >
        <StyledLabelNew
          treatmentFormName={treatmentFormName}
          htmlFor={withFormId('email')}
          finderForm={formName === 'FinderForm'}
          flowForm={formName === 'MiniFlowForm'}
        >
          {`${t('Email')}*`}
        </StyledLabelNew>
        <FastField
          name="email"
          id={withFormId('email')}
          component={Input}
          displayName={t('Email')}
          inputComponent={StyledInput}
        />
      </StyledCustomEmailUnit>

      <StyledCustomEmailUnit
        size={{ mobile: 1, desktop: customEmailDesktopSize }}
        treatmentFormName={treatmentFormName}
      >
        <StyledLabelNew
          treatmentFormName={treatmentFormName}
          finderForm={formName === 'FinderForm'}
          flowForm={formName === 'MiniFlowForm'}
        >
          {`${t('Phone')}*`}
        </StyledLabelNew>
        <FastField name="phone">
          {({ field }) => <InputPhone field={field} onChange={handlePhoneChange} />}
        </FastField>

        {touched.phone && errors.phone && (
          <StyledValidationMessage>
            {errors.phone}
          </StyledValidationMessage>
        )}

      </StyledCustomEmailUnit>

      <StyledtextGridUnit treatmentFormName={treatmentFormName}>
        <StyledLabelNew
          treatmentFormName={treatmentFormName}
          htmlFor={withFormId('textarea')}
          finderForm={formName === 'FinderForm'}
          flowForm={formName === 'MiniFlowForm'}
        >
          {newt('MiniFlow.AddNotes')}
        </StyledLabelNew>
        <FastField
          name="notes"
          id={withFormId('notes')}
          component={Textarea}
          inputComponent={StyledTextArea}
          placeholder={newt('MiniFlow.NotesPlaceholder')}
        />
      </StyledtextGridUnit>

      <StyledItem treatmentFormName={treatmentFormName}>
        <TermsAndConditionsWrapper treatmentFormName={treatmentFormName}>
          <Checkbox
            checked={checkboxChecked}
            id={withFormId('checkboxTermsAndConditions')}
            onChange={setCheckboxChecked}
            treatmentFormName={treatmentFormName}
          />
          <StyledLabelTextWrapper
            treatmentFormName={treatmentFormName}
            finderForm={formName === 'FinderForm'}
            flowForm={formName === 'MiniFlowForm'}
          >
            <Trans i18nKey="ContactPage:ClickTermsAndConditions" />
          </StyledLabelTextWrapper>
        </TermsAndConditionsWrapper>
      </StyledItem>

      <StyledItem submitButton treatmentFormName={treatmentFormName}>
        <StyledButtonSubmit
          treatmentFormName={treatmentFormName}
          isModal={isModal}
          full
          type="submit"
          id="ContactFormID"
          onClick={() => {
            handleSubmit();
            setFormCreated(true);
          }}
          disabled={!checkboxChecked || isAnyValueEmpty || sending || !(values.phone.length > 5)}
        >
          {t('Submit')}
        </StyledButtonSubmit>
      </StyledItem>
    </StyledFormGrid>
  );
};

const handleSubmit = (
  formValues,
  {
    props: {
      createCandidate,
      addressCity,
      departments,
      treatment,
      modalState,
      doctor,
      hospital,
      speciality,
      hours,
      time,
      contactUs,
      location,
      contract,
      i18n: { language },
      router: { query }
    }
  }
): void => {
  createCandidate({
    ...formValues,
    preferred_city: addressCity || formValues.address_city,
    address_city: addressCity || formValues.address_city,
    password: formValues.password,
    hours,
    time,
    contactUs,
    location,
    contract,
    departments,
    treatment,
    modalState,
    doctor,
    hospital,
    speciality,
    language,
    source: query.s
  });
};
const trackCreated = async (treatmentPage) => {
  const { default: ReactPixel } = await import('react-facebook-pixel');
  ReactPixel.init('370952911555724');
  ReactPixel.trackCustom('LeadCreated');

  TagManager.dataLayer({
    dataLayerName: DATA_LAYER_NAME,
    dataLayer: {
      event: 'PatientCreated',
      treatmentPage
    }
  });
};

const mapStateToProps = (
  {
    candidateCreate: {
      sending, created, error, created_patient_id, modalCreated
    }
  }: GlobalState,
  props: any
) => ({
  sending,
  created,
  modalCreated,
  error,
  created_patient_id,
  initialFormValues: {
    data: {
      attributes: {
        treatment: props.treatment || '',
        department: props.department || '',
        password: props.password,
        address_city: props.addressCity
      }
    }
  }
});

const mapDispatchToProps = {
  createCandidate,
  resetCandidateCreate
};

const ContactPageNew = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withTranslation(['ContactPage']),
  withFormik({
    validate: (values) => {
      const errors = {};

      if (!values.phone || !phone(values.phone).isValid) {
        errors.phone = 'Please enter a valid phone number';
      }
      return errors;
    },

    handleSubmit,
    formSubmit: true,
    fieldNames,
    reduxErrorKey: 'error',
    reduxInitialValuesKey: 'initialFormValues'
  })
)(ContactPageComponent);

ContactPageNew.getInitialProps = (): {} => ({
  namespacesRequired: ['ContactPage']
});

export default ContactPageNew;
